import './IdentificationNotBiometricModal.scss';

import React from 'react';
import { ModalComponent } from 'components/modal/modalComponent';
import BiometricFace from 'assets/images/biometric-face.svg';
import { formatText } from 'core/i18n';

export const IdentificationNotBiometricModal = ({ showModal, onConfirm, onCancel }) => (
    <>
        <ModalComponent
            isOpen={showModal}
            title={formatText('identificationNotBiometric-identifyWithoutBiometricData')}
            confirmText={formatText('identificationNotBiometric-continueWithoutBiometric')}
            onConfirm={onConfirm}
            cancelText={formatText('identificationNotBiometric-returnWithBiometric')}
            onCancel={onCancel}
            className="identification-not-biometric-modal"
        >
            <div className="identification-not-biometric-modal identification-not-biometric-modal__content">
                <img src={BiometricFace} alt="biometric-face" />
                <p>{formatText('identificationNotBiometric-alternativeWithoutBiometricData')}</p>
            </div>
        </ModalComponent>
    </>
);
